export enum RequestStepStatusEnum {
  New = 'New',
  InProgress = 'In Progress',
  Completed = 'Completed'
}
